import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { api } from "../../../services/api/axios";

const fetchAnnouncements = async () => {
  const { data } = await api.get("/v1/admin/personal/announcements");
  return data.data;
};

export const useAnnouncements = () =>
  useQuery({
    queryKey: ["announcements"],
    queryFn: fetchAnnouncements,
    refetchOnWindowFocus: false,
  });

export const useCreateAnnouncement = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (payload) => {
      const { data } = await api.post("/v1/admin/personal/announcements", payload);
      return data.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["announcements"] });
      toast.success("Announcement published. Users see it in their notifications.");
    },
    onError: (err) => {
      const message = err?.response?.data?.message;
      toast.error(
        Array.isArray(message) ? message.join(", ") : message || "Could not publish"
      );
    },
  });
};

export const useRemoveAnnouncement = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (uuid) => {
      const { data } = await api.delete(`/v1/admin/personal/announcements/${uuid}`);
      return data.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["announcements"] });
      toast.success("Announcement removed");
    },
    onError: (err) => {
      toast.error(err?.response?.data?.message || "Could not remove");
    },
  });
};
